import { useQuery } from '@apollo/client';
import { Sparkles } from '@react-three/drei';
import FlipCard from 'componentsFor3D/FlipCard';
import ShineEffect from 'componentsFor3D/ShineEffect';
import { GetProductsByCollection } from 'graphql/query';

const posArray = [
  [-7, -1, -7],
  [-6, -1.4, 8],
  [10, -6, 1],
  [-6, -6, -6],
  [12, -2.3, -10],
  [0, 0, 10],
];

type Props = {
  collectionHandle?: string;
  orbit?: any;
};

export default function ProductList({
  collectionHandle = 'Chapter1A',
  orbit = null,
}: Props) {
  const { data } = useQuery(GetProductsByCollection, {
    variables: { collectionHandle },
  });
  return (
    <group>
      {data?.collectionByHandle?.products?.edges?.map(
        (node: any, index: number) => (
          <FlipCard
            key={index}
            title={node.node.title}
            url={node.node.images.edges[0].node.originalSrc}
            pos={posArray[index]}
            description={node.node.description}
            price={node.node.variants.edges[0].node.priceV2.amount}
            orbit={orbit}
            variantId={node.node.variants.edges[0].node.id}
            id={node.node.id}
          />
        )
      )}
      <ShineEffect url='assets/shine.png' pos={[-9, 0, -8]} id={'shine'} />
      <ShineEffect url='assets/shine.png' pos={[-6, 1, -8]} id={'shine'} />
      <Sparkles
        count={10}
        position={[-5, 1, -5]}
        scale={[7, 3, 7]}
        size={30}
        speed={0.6}
      />
    </group>
  );
}
